import { Thresholds } from './tresholds';

export const daysUntilNextVisitToColorKey = (
  daysUntilNextVisit: number,
): 'blue' | 'green' | 'yellow' | 'red' => {
  if (daysUntilNextVisit > Thresholds.LOW) {
    return 'blue';
  } else if (
    daysUntilNextVisit <= Thresholds.LOW &&
    daysUntilNextVisit >= Thresholds.MIDDLE
  ) {
    return 'green';
  } else if (
    daysUntilNextVisit < Thresholds.MIDDLE &&
    daysUntilNextVisit >= Thresholds.HIGH
  ) {
    return 'yellow';
  } else {
    return 'red';
  }
};
